<app-base-template (modal)="openModal(content)" (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage"[dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Add Activity Mail Template</div>

  </div>
  <div class="modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="ticketSelected"
              (change)="onTicketChange($event.target.selectedIndex)">
        <option *ngFor="let ticket of tickets" [value]="ticket.id">{{ticket.name}}</option>
      </select>
    </div>

    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="activitySelected"
              (change)="onActivityChange($event.target.selectedIndex)">
        <option *ngFor="let activity of activity_desc" [value]="activity.id">{{activity.activity_desc}}</option>
      </select>
    </div>

    <!--<label class="font-13">Support group</label>-->
    <!--<div class="form-group font-13 box">-->
    <!--<mat-checkbox *ngFor="let group of support_group" value="{{group.id}}" [(ngModel)]="group.checked">{{group.name}}</mat-checkbox>-->
    <!--</div>-->

    <!--<label class="font-13">Category</label>-->
    <!--<div class="form-group font-13 box">-->
    <!--<mat-checkbox *ngFor="let category of categories" value="{{category.id}}" [(ngModel)]="category.checked">{{category.name}}</mat-checkbox>-->
    <!--</div>-->

    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="categorySelected"
              (change)="onCategoryChange($event.target.selectedIndex)">
        <option *ngFor="let category of categories" [value]="category.id">{{category.name}}</option>
      </select>
    </div>


    <div class="form-group">
      <textarea class="form-control radius-0 font-13" [(ngModel)]="subject" placeholder="Subject" required></textarea>
    </div>

    <ck-editor name="editor1" [(ngModel)]="editorValue" skin="moono-lisa" language="en" [fullPage]="true" placeholder="Template body"></ck-editor>
  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>
<notifier-container></notifier-container>

